<!-- <div class="cssload-container flex w-full" *ngIf="!circle && coloring.length">
<div [ngStyle]="{'backgroundColor': colors[0]}"></div>
<div [ngStyle]="{'backgroundColor': colors[1]}"></div>
<div [ngStyle]="{'backgroundColor': colors[2]}"></div>
<div [ngStyle]="{'backgroundColor': colors[3]}"></div>
</div>
<div class="circle-loader-wrapper" *ngIf="circle && coloring.length">
  <div class="circle circle-one" [ngStyle]="{'borderTopColor': coloring[0], 'borderLeftColor': coloring[0]}"></div>
  <div class="circle circle-two" [ngStyle]="{'borderTopColor': coloring[1], 'borderLeftColor': coloring[1]}"> </div>
  <div class="circle circle-three" [ngStyle]="{'borderTopColor': coloring[2], 'borderLeftColor': coloring[2]}"></div>
  <div class="circle circle-four" [ngStyle]="{'borderTopColor': coloring[3], 'borderLeftColor': coloring[3]}"></div>
  <div class="info" [ngStyle]="{'color': coloring[coloring.length - 1].color}">
    <div class="icon" *ngIf="icon"><i class="icon-{{icon}}"></i></div>
    <div class="label" *ngIf="label" [innerHtml]="label"></div>
  </div>
</div> -->

<div class="loader">
  <div class="loader-spinner" [class.auto-colors]="autoColors">
    <div
      class="circle"
    [ngStyle]="{'borderTopColor': !ignoreColors && !autoColors ? coloring[0] : null}"></div>
    <div
      class="circle"
    [ngStyle]="{'borderTopColor': !ignoreColors && !autoColors ? coloring[1]: null}"></div>
    <div
      class="circle"
    [ngStyle]="{'borderTopColor': !ignoreColors && !autoColors ? coloring[2]: null}"></div>
    <div
      class="circle"
    [ngStyle]="{'borderTopColor': !ignoreColors && !autoColors ? coloring[3]: null}"></div>
  </div>
  <div
    class="info flex center"
    [ngStyle]="{'color': coloring[3]}">
    @if (icon) {
      <div
        class="icon"
        >
        <i class="icon-{{icon}}"></i>
      </div>
    }
  </div>
  @if (label) {
    <div
      class="label"
    [innerHtml]="label"></div>
  }
  <ng-content></ng-content>
</div>
